var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.25C25.1086 29.25 29.25 25.1086 29.25 20C29.25 14.8914 25.1086 10.75 20 10.75C14.8914 10.75 10.75 14.8914 10.75 20C10.75 25.1086 14.8914 29.25 20 29.25ZM20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20C30 25.5228 25.5228 30 20 30Z",
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 20C27.625 20.2071 27.4571 20.375 27.25 20.375C27.0429 20.375 26.875 20.2071 26.875 20C26.875 16.203 23.797 13.125 20 13.125C16.203 13.125 13.125 16.203 13.125 20C13.125 20.2071 12.9571 20.375 12.75 20.375C12.5429 20.375 12.375 20.2071 12.375 20C12.375 15.7888 15.7888 12.375 20 12.375C24.2112 12.375 27.625 15.7888 27.625 20Z",
    fill: "#FF6060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 21.625C19.2966 21.625 18.625 20.9534 18.625 20.125C18.625 19.2966 19.2966 18.625 20.125 18.625C20.9534 18.625 21.625 19.2966 21.625 20.125C21.625 20.9534 20.9534 21.625 20.125 21.625ZM20.125 20.875C20.5392 20.875 20.875 20.5392 20.875 20.125C20.875 19.7108 20.5392 19.375 20.125 19.375C19.7108 19.375 19.375 19.7108 19.375 20.125C19.375 20.5392 19.7108 20.875 20.125 20.875Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.125C20.5 14.9179 20.3321 14.75 20.125 14.75C19.9179 14.75 19.75 14.9179 19.75 15.125V18.625C19.75 18.8321 19.9179 19 20.125 19C20.3321 19 20.5 18.8321 20.5 18.625V15.125Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8589 21.2312C26.9103 21.0306 27.1146 20.9096 27.3153 20.9611C27.5159 21.0125 27.6368 21.2168 27.5854 21.4174C27.354 22.32 26.9771 23.1441 26.4551 23.8875C25.9317 24.633 25.5553 25.0814 25.2822 25.2634C25.1099 25.3782 24.877 25.3316 24.7622 25.1593C24.6473 24.9869 24.694 24.7541 24.8663 24.6393C25.0336 24.5278 25.3731 24.1233 25.8413 23.4565C26.3109 22.7877 26.6499 22.0467 26.8589 21.2312Z",
    fill: "#7BC658"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 26.25C24.3321 26.25 24.5 26.0821 24.5 25.875C24.5 25.6679 24.3321 25.5 24.125 25.5C23.9179 25.5 23.75 25.6679 23.75 25.875C23.75 26.0821 23.9179 26.25 24.125 26.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2d065d7822c02e19bdc263bb72491be8.svg";
export { ForwardRef as ReactComponent };